// The only ambient browser clock boundary; all state machines receive this port.
export const browserDeliveryClock = Object.freeze({
  visible: () => document.visibilityState === 'visible',
  frame: task => window.requestAnimationFrame(task),
  cancelFrame: frame => window.cancelAnimationFrame(frame),
  onVisibility: task => {
    document.addEventListener('visibilitychange', task);
    return () => document.removeEventListener('visibilitychange', task);
  },
  now: () => performance.now(),
  delay: (task, milliseconds) => window.setTimeout(task, milliseconds),
  cancel: timer => window.clearTimeout(timer),
});
